import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SettingsButton } from './styled.js';
import { removeCompetitor, removeSubscription } from './actions.js';

class RemoveEntityButton extends Component {
  render() {
    const { id, remove } = this.props;

    return (
      <SettingsButton onClick={() => remove(id)}>
        REMOVE
      </SettingsButton>
    );
  }
}

const mapDispatchToProps = (dispatch, { type }) => ({
  remove: id => type === 'competitor' ?
    dispatch(removeCompetitor(id)) :
    dispatch(removeSubscription(id)),
});

export default connect(null, mapDispatchToProps)(RemoveEntityButton);
